<template>
  <el-menu
    class="sidebar"
    background-color="#113fa9"
    :unique-opened="false"
    :default-active="activeIndex"
    @select="handleSelect"
  >
    <router-link :to="{ name: 'dashboard' }" @click.native="resetActiveIndex">
      <div class="logo">
        <img
          :src="require('@/assets/svg/logo.svg')"
          style="width: 200px; height: auto;"
        />
        <small>
          {{ empresa.muni_descripcion }}
        </small>
      </div>
    </router-link>

    <div style="padding-top: 20px;">
      <router-link
        v-if="profile == 1"
        :to="{ name: 'users.index' }"
        style="text-decoration: none"
        class="menu-padre"
      >
        <el-menu-item index="1">
          <el-row style="height: 30px;">
            <el-col>
              <img :src="require('@/assets/svg/users.svg')" />
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <small style="color: white">Usuarios</small>
            </el-col>
          </el-row>
        </el-menu-item>
      </router-link>

      <section
        v-for="item in menu"
        :key="'menu_' + item.arme_id"
        class="menu-padre"
      >
        <el-menu-item
          :index="'menu_' + item.arme_id"
          @click.native="
            redirectToPath(item.arme_ruta, item.arme_tipo, item.arme_id)
          "
        >
          <el-row style="height: 30px;">
            <el-col>
              <img
                v-if="item.arme_nombre == 'CONSULTAR'"
                :src="require('@/assets/svg/consultar.svg')"
              />
              <img
                v-else-if="item.arme_nombre == 'GRABAR'"
                :src="require('@/assets/svg/grabar.svg')"
              />
              <img
                v-else-if="item.arme_nombre == 'INDICADORES'"
                :src="require('@/assets/svg/indicadores.svg')"
              />
              <img
                v-else-if="item.arme_nombre == 'INFORMES'"
                :src="require('@/assets/svg/informes.svg')"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <small style="color: white">
                {{ item.arme_nombre }}
              </small>
            </el-col>
          </el-row>
        </el-menu-item>
      </section>

      <el-submenu index="2" v-if="profile == 1">
        <template #title>
          <el-row justify="center" align="middle">
            <el-col>
              <img :src="require('@/assets/svg/settings.svg')" />
            </el-col>
          </el-row>
        </template>
        <el-menu-item-group>
          <router-link
            :to="{ name: 'menu.profile.index' }"
            style="text-decoration: none"
            class="item-submenu"
          >
            <el-menu-item index="2-1">
              <el-row justify="center" align="middle">
                <el-col>
                  <small style="color: white">Menú Perfil</small>
                </el-col>
              </el-row>
            </el-menu-item>
          </router-link>
          <router-link
            :to="{ name: 'menu.user.index' }"
            style="text-decoration: none"
            class="item-submenu"
          >
            <el-menu-item index="2-2">
              <el-row justify="center" align="middle">
                <el-col>
                  <small style="color: white">Menú Usuario</small>
                </el-col>
              </el-row>
            </el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu>
    </div>
  </el-menu>
</template>

<script>
  import { getMenuUser } from '@/api/menu_build'
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        activeIndex: '',
        menu: [],
        profile: null
      }
    },
    created() {
      this.loadMenu()
    },
    methods: {
      loadMenu() {
        let user_id = JSON.parse(localStorage.getItem('siapusr')).usua_id
        getMenuUser(user_id).then(response => {
          this.menu = response.data
          localStorage.setItem('menu', JSON.stringify(response.data))
          this.profile = response.data[0].arpe_id
        })
      },
      handleSelect(index) {
        this.activeIndex = index
      },
      resetActiveIndex() {
        this.activeIndex = ''
      },
      redirectToPath(path, arme_tipo, arme_id) {
        const fullPath = `${path}/${arme_tipo}/${arme_id}`
        this.$router.push({ path: fullPath })
      }
    },
    computed: {
      ...mapGetters(['empresa', 'usuario'])
    }
  }
</script>

<style scoped>
  .sidebar {
    width: 185px;
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
    border: none;
    background: linear-gradient(135deg, #113fa9, #00c4ff);
  }
  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #fff;
  }
  .el-menu-item {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: transparent !important;
  }
  .el-menu-item.is-active {
    border-left: 3px solid #fff;
    border-radius: 2px;
    color: none;
  }
  .el-menu-item:hover {
    outline: 0;
    background-color: transparent !important;
  }
  .el-menu-item:focus {
    outline: 0;
    background-color: transparent !important;
  }
  .menu-padre {
    padding: 20px 20px 20px 20px;
    margin: auto;
    width: 100%;
  }
  /* estilos submenu */

  :deep(.el-submenu__title) {
    padding: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    color: #fff;
    background-color: transparent !important;
  }
  :deep(.el-menu-item-group__title) {
    padding: 0 !important;
  }

  .item-submenu .el-menu-item {
    padding: 0 !important;
    height: 2rem;
    width: 100%;
    background: linear-gradient(135deg, #113fa9, #00c4ff);
  }
  .item-submenu:hover {
    background-color: transparent;
    text-decoration: none;
  }

  .el-submenu.is-opened {
    background-color: transparent;
  }
  .el-submenu:active {
    background-color: transparent;
  }

  .item-submenu {
    color: #fff;
    text-decoration: none;
    display: flex;
    justify-content: center;
    padding: 0;
  }
</style>
